module.exports = ["just nu",["%s sekund sedan","%s sekunder sedan"],["%s minut sedan","%s minuter sedan"],["%s timme sedan","%s timmar sedan"],["%s dag sedan","%s dagar sedan"],["%s vecka sedan","%s veckor sedan"],["%s månad sedan","%s månader sedan"],["%s år sedan","%s år sedan"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/sv-SV.json
// module id = 5ygq
// module chunks = 1